(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 95537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close'));

/***/ }),

/***/ 96506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search'));

/***/ }),

/***/ 57286:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(23916);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/layouts/MainLayout/index.js + 15 modules
var MainLayout = __webpack_require__(34316);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(22283);
// EXTERNAL MODULE: ./src/sections/home/index.js + 27 modules
var home = __webpack_require__(86874);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(21987);
// EXTERNAL MODULE: ./node_modules/@mui/material/Pagination/Pagination.js
var Pagination = __webpack_require__(64840);
// EXTERNAL MODULE: ./node_modules/@mui/material/PaginationItem/PaginationItem.js + 2 modules
var PaginationItem = __webpack_require__(88833);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Breadcrumbs/index.js + 1 modules
var Breadcrumbs = __webpack_require__(53276);
// EXTERNAL MODULE: ./src/api/blogs.js
var blogs = __webpack_require__(20339);
// EXTERNAL MODULE: ./src/components/useQueryState/index.js + 2 modules
var useQueryState = __webpack_require__(36401);
// EXTERNAL MODULE: ./src/imports/NextLink/index.js + 1 modules
var NextLink = __webpack_require__(94369);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/imports/SearchTextField/index.js + 1 modules
var SearchTextField = __webpack_require__(96571);
;// CONCATENATED MODULE: ./src/sections/blogs/BlogsSection.js












function BlogsSection() {
    var _blogsQuery_data, _blogsQuery_data_data, _blogsQuery_data1, _blogsQuery_data_meta;
    const { t , i18n  } = (0,esm/* useTranslation */.$G)([
        "common",
        "blog"
    ]);
    const [page, setPage] = (0,useQueryState/* default */.Z)("page", {
        defaultValue: 1,
        type: "integer"
    });
    const [search, setSearch] = (0,useQueryState/* default */.Z)("q", {
        defaultValue: "",
        type: "string"
    });
    const router = (0,next_router.useRouter)();
    const blogsQuery = (0,blogs/* useBlogs */.Ub)(page, router.locale, undefined, search);
    react.useEffect(()=>{
        if (page !== 1) setPage(1);
    }, [
        router.locale
    ]);
    var _blogsQuery_data_meta_last_page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mt: 10,
        mb: 7,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mb: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 1,
                            flexDirection: "row-reverse",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: "auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTextField/* default */.Z, {
                                        fullWidth: true,
                                        placeholder: t("common:search"),
                                        searchState: [
                                            search,
                                            setSearch
                                        ],
                                        backgroundColor: "paper.main",
                                        size: "small",
                                        isLoading: blogsQuery.isRefetching,
                                        sx: {
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "40px",
                                                backgroundColor: "paper.main",
                                                pl: 2,
                                                pr: 3,
                                                transition: (theme)=>theme.transitions.create([
                                                        "width"
                                                    ], {
                                                        easing: theme.transitions.easing.sharp,
                                                        duration: theme.transitions.duration.leavingScreen
                                                    })
                                            }
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h5",
                                        gutterBottom: true,
                                        children: t("blog:Blog")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            items: [
                                {
                                    text: t("blog:home"),
                                    url: "/"
                                },
                                {
                                    text: t("blog:blog")
                                }
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 4,
                    alignItems: "stretch",
                    children: [
                        (_blogsQuery_data = blogsQuery.data) === null || _blogsQuery_data === void 0 ? void 0 : (_blogsQuery_data_data = _blogsQuery_data.data) === null || _blogsQuery_data_data === void 0 ? void 0 : _blogsQuery_data_data.map((param)=>/*#__PURE__*/ {
                            let { id , slug , title , description , image , created_at: createdAt  } = param;
                            return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                md: 4,
                                xl: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                                    sx: {
                                        borderRadius: 2,
                                        overflow: "hidden",
                                        height: "100%",
                                        cursor: "pointer",
                                        display: "block",
                                        transition: (theme)=>theme.transitions.create([
                                                "transform"
                                            ], {
                                                easing: theme.transitions.easing.sharp,
                                                duration: theme.transitions.duration.leavingScreen
                                            }),
                                        ":hover": {
                                            transform: "scale(1.02)"
                                        }
                                    },
                                    component: NextLink/* default */.Z,
                                    href: "/blog/".concat(slug),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            loading: "eager",
                                            src: image !== null && image !== void 0 ? image : "/images/video-poster.webp",
                                            style: {
                                                width: "100%",
                                                height: "auto",
                                                objectFit: "cover"
                                            },
                                            alt: "blog image",
                                            width: "1000",
                                            height: "1000"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            px: 2,
                                            pt: 0.5,
                                            pb: 1.5,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "caption",
                                                    color: "neutral.dark",
                                                    fontWeight: 500,
                                                    display: "block",
                                                    sx: {
                                                        pb: 2
                                                    },
                                                    children: moment_default()(createdAt).locale(i18n.language).format("LL")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h6",
                                                    fontWeight: 600,
                                                    gutterBottom: true,
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "subtitle2",
                                                    fontSize: 16,
                                                    gutterBottom: true,
                                                    sx: {
                                                        fontSize: "16px !important",
                                                        overflow: "hidden",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: "3  ",
                                                        lineClamp: "3 ",
                                                        WebkitBoxOrient: "vertical"
                                                    },
                                                    children: description
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            container: true,
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                color: "primary",
                                sx: {
                                    mt: 5,
                                    "& .MuiSvgIcon-root": {
                                        transform: "scale(1) !important"
                                    }
                                },
                                count: (_blogsQuery_data_meta_last_page = (_blogsQuery_data1 = blogsQuery.data) === null || _blogsQuery_data1 === void 0 ? void 0 : (_blogsQuery_data_meta = _blogsQuery_data1.meta) === null || _blogsQuery_data_meta === void 0 ? void 0 : _blogsQuery_data_meta.last_page) !== null && _blogsQuery_data_meta_last_page !== void 0 ? _blogsQuery_data_meta_last_page : 0,
                                renderItem: (item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationItem/* default */.Z, {
                                        sx: {
                                            fontFamily: "var(--cairo-font) !important"
                                        },
                                        ...item
                                    }),
                                page: page,
                                onChange: (_, value)=>setPage(value)
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var blogs_BlogsSection = ((/* unused pure expression or super */ null && (BlogsSection)));

;// CONCATENATED MODULE: ./src/sections/blogs/index.js


;// CONCATENATED MODULE: ./pages/blog/index.js







function Index() {
    const { t  } = (0,esm/* useTranslation */.$G)([
        "blog"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "".concat(t("blog:Blog"), " - Blue Assembly")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.C, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogsSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home/* PreFooterSection */.jq, {})
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var blog = ((0,esm/* withTranslation */.Zh)([
    "common"
])(Index));


/***/ }),

/***/ 20339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ub": function() { return /* binding */ useBlogs; },
/* harmony export */   "f8": function() { return /* binding */ useBlogTopic; }
/* harmony export */ });
/* unused harmony exports KEYS, getBlogs, prefetchBlogs, getBlogTopic, prefetchBlogTopic */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67848);
/* harmony import */ var _httpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16799);


const KEYS = {
    BLOGS: "blogs"
};
const getBlogs = async (param)=>{
    let { pageParam =1 , language ="en" , isTrending =undefined , search =""  } = param;
    const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.get */ .M.get("/blogs", {
        params: {
            page: pageParam,
            language,
            limit: 10,
            ...typeof isTrending !== "undefined" ? {
                is_trending: isTrending
            } : {},
            q: search
        }
    });
    return response.data;
};
const useBlogs = function() {
    let pageParam = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en", isTrending = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined, search = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        KEYS.BLOGS,
        "page=".concat(pageParam),
        "language=".concat(language),
        "is_trending=".concat(isTrending),
        "search=".concat(search)
    ], async ()=>getBlogs({
            pageParam,
            language,
            search,
            isTrending
        }), {
        keepPreviousData: true
    });
};
const prefetchBlogs = function(queryClient) {
    let pageParam = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, language = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en", isTrending = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined, search = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    return queryClient.prefetchQuery([
        KEYS.BLOGS,
        "page=".concat(pageParam),
        "language=".concat(language),
        "is_trending=".concat(isTrending),
        "search=".concat(search)
    ], async ()=>getBlogs({
            pageParam,
            language,
            search,
            isTrending
        }));
};
const getBlogTopic = async (slug)=>{
    const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.get */ .M.get("/blogs/".concat(slug));
    return response.data;
};
const prefetchBlogTopic = function(queryClient, slug) {
    let language = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en";
    return queryClient.prefetchQuery([
        KEYS.BLOGS,
        "slug=".concat(slug),
        "language=".concat(language)
    ], async ()=>getBlogTopic(slug, language));
};
const useBlogTopic = function(slug) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en";
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        KEYS.BLOGS,
        "slug=".concat(slug),
        "language=".concat(language)
    ], async ()=>getBlogTopic(slug, language));
};


/***/ }),

/***/ 53276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// UNUSED EXPORTS: Breadcrumbs

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(8041);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./src/imports/NextLink/index.js + 1 modules
var NextLink = __webpack_require__(94369);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs/Breadcrumbs.js




function ItemTrace(param) {
    let { icon ="/" , items  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
        separator: icon,
        "aria-label": "breadcrumb",
        children: items.map((param, index)=>{
            let { text , url  } = param;
            return url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                color: "inherit",
                href: url,
                style: {
                    fontSize: "16px",
                    textTransform: "capitalize"
                },
                children: text
            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                color: "#000",
                variant: "caption",
                textTransform: "capitalize",
                children: text
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Breadcrumbs/index.js


/* harmony default export */ var components_Breadcrumbs = (ItemTrace);


/***/ }),

/***/ 36401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_useQueryState; }
});

// UNUSED EXPORTS: useQueryState

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/useQueryState/queryTypes.js
const queryTypes = {
    string: {
        parse: (query, defaultValue)=>query !== undefined ? query : defaultValue,
        serialize: (value)=>value
    },
    integer: {
        parse: (query, defaultValue)=>query !== undefined ? parseInt(query) : defaultValue,
        serialize: (value)=>value
    },
    array: {
        parse: (query, defaultValue)=>query !== undefined ? JSON.parse(query) : defaultValue,
        serialize: (values)=>JSON.stringify(values !== null && values !== void 0 ? values : [])
    }
};
/* harmony default export */ var useQueryState_queryTypes = (queryTypes);

;// CONCATENATED MODULE: ./src/components/useQueryState/useQueryState.js



function useQueryState(key, param) {
    let { defaultValue ="" , type ="string"  } = param;
    const router = (0,next_router.useRouter)();
    const queryTypeHandler = useQueryState_queryTypes[type];
    const [filter, setFilter] = react.useState(defaultValue);
    const setQueryFilter = (value)=>{
        if (router.query[key] !== queryTypeHandler.serialize(value)) {
            router.query[key] = queryTypeHandler.serialize(value);
            router.push(router, null, {
                shallow: true
            });
        }
    };
    react.useEffect(()=>{
        setFilter(queryTypeHandler.parse(router.query[key], defaultValue));
    }, [
        queryTypeHandler.serialize(router.query[key])
    ]);
    return [
        filter,
        setQueryFilter
    ];
}
/* harmony default export */ var useQueryState_useQueryState = (useQueryState);

;// CONCATENATED MODULE: ./src/components/useQueryState/index.js


/* harmony default export */ var components_useQueryState = (useQueryState_useQueryState);


/***/ }),

/***/ 96571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ imports_SearchTextField; }
});

// UNUSED EXPORTS: SearchTextField

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/FlatTextField/index.js + 1 modules
var FlatTextField = __webpack_require__(35133);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(91057);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(66489);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Search.js
var Search = __webpack_require__(96506);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Close.js
var Close = __webpack_require__(95537);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/imports/SearchTextField/SearchTextField.js






function SearchTextField(param) {
    let { searchState =[] , size ="medium" , InputProps ={} , isLoading =false , ...props } = param;
    const [search, setSearch] = searchState;
    const handleSearchChange = react.useCallback((0,lodash.debounce)((value)=>setSearch(value), 500), []);
    const textRef = react.useRef(search);
    react.useEffect(()=>{
        textRef.current.value = search;
    }, [
        search
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
        ref: textRef,
        onChange: (e)=>handleSearchChange(e.target.value),
        backgroundColor: "white",
        size: size,
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
            }),
            endAdornment: !!search && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                onClick: ()=>setSearch(""),
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                    size: 14
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    size: size,
                    edge: "end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                        fontSize: "inherit"
                    })
                })
            }),
            ...InputProps
        },
        ...props
    });
}
/* harmony default export */ var SearchTextField_SearchTextField = (SearchTextField);

;// CONCATENATED MODULE: ./src/imports/SearchTextField/index.js


/* harmony default export */ var imports_SearchTextField = (SearchTextField_SearchTextField);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6,809,718,558,367,172,984,316,874,774,888,179], function() { return __webpack_exec__(57286); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);